module.exports = __webpack_public_path__ + "img/item_3.a9342966.png";